import React from 'react';
export const Opening = () => {
  return <section className="py-20 relative overflow-hidden" style={{
    background: 'linear-gradient(to bottom, #FAF5EA 0%, #FAF5EA 10%, #F4E9DC 25%, #E8D5C4 45%, #E8D5C4 70%, #F4E9DC 88%, #FAF5EA 100%)'
  }} data-id="element-411">
      {/* Spotlight from top */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1000px] h-[500px] pointer-events-none z-[2]" data-id="element-412">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_rgba(212,180,131,0.3),_rgba(245,230,200,0.1)_40%,_transparent_70%)]" data-id="element-413"></div>
        <div className="absolute top-12 left-[18%] w-3 h-3 bg-gold-300/40 rounded-full blur-[2px]" data-id="element-414"></div>
        <div className="absolute top-32 right-[22%] w-5 h-5 bg-gold-400/25 rounded-full blur-md" data-id="element-415"></div>
        <div className="absolute top-48 left-[30%] w-2 h-2 bg-white/50 rounded-full blur-[1px]" data-id="element-416"></div>
        <div className="absolute top-20 right-[40%] w-6 h-6 bg-beige-100/40 rounded-full blur-lg" data-id="element-417"></div>
      </div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-418">
        <div className="text-center mb-10" data-id="element-419">
          <h2 className="text-3xl md:text-4xl font-serif text-neutral-900 leading-tight" data-id="element-420">
            ¿Cuántas horas de tu vida{' '}
            <span className="metallic-gold-text italic" data-id="element-421">has perdido</span>
            ...
          </h2>
        </div>

        <div className="bg-white/80 backdrop-blur-sm rounded-3xl p-8 md:p-12 shadow-xl shadow-gold-900/10 border border-white/60" data-id="element-422">
          <div className="space-y-6 text-lg md:text-xl text-neutral-700 font-light leading-relaxed text-center" data-id="element-423">
            <p data-id="element-424">
              ...frente al espejo, luchando contra un cabello que simplemente no
              coopera?
            </p>
            <p data-id="element-425">
              La plancha caliente. El secador. La crema anti-frizz que prometía
              maravillas y duró tres días. El día que llovió y todo tu trabajo
              desapareció en cinco minutos.
            </p>
            <p className="font-serif font-medium text-neutral-900 text-2xl" data-id="element-426">
              No es tu culpa. Es que nadie te ha dado la solución correcta.
            </p>
            <p data-id="element-427">
              Durante años, la industria de la belleza te vendió alisados
              agresivos cargados de formol y químicos que prometían resultados,
              pero que poco a poco fueron debilitando, resecando y dañando tu
              cabello. Y cuando los resultados se iban en semanas, regresabas a
              empezar el ciclo otra vez.
            </p>
            <p className="font-serif font-medium italic text-xl md:text-2xl pt-4 border-t border-champagne-300/40" data-id="element-428">
              <span className="metallic-gold-text-static" data-id="element-429">
                Pero existe algo diferente. Algo que no solo alisa tu cabello —
                sino que lo transforma desde adentro. Y los resultados hablan
                por sí solos.
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>;
};